<p-progressBar mode="indeterminate" [style]="{'height': '3px','width':'50%','top':'50%','left':'30%','z-index':'20004'}"></p-progressBar>
